import { FunctionComponent } from 'react'
import { Campaign, CampaignAddon, User } from '../../gql/types'
import { Divider } from '../Divider'
import { CreatorRequirementsBrief } from './CreatorRequirementsBrief'
import { EnterpriseBrief } from './EnterpriseBrief'
import { InspirationBrief } from './InspirationBrief'
import { ProductBrief } from './ProductBrief'
import { VideoBrief } from './VideoBrief'
import { CampaignInfoBrief } from './CampaignInfoBrief'

interface IDefaultProps {
  // if this viewed by the creator or the brand
  viewMode?: 'brand' | 'creator'
  className?: string
}

interface IProps extends Partial<IDefaultProps> {
  campaign: Campaign
  hooks?: string[]
  addons?: CampaignAddon[]
  isCampaignInfoBrief?: boolean
}
const defaultProps: IDefaultProps = {
  viewMode: 'brand',
}

const CampaignDetailsBrief: FunctionComponent<IProps> = ({
  campaign,
  viewMode,
  hooks,
  addons,
  className,
  isCampaignInfoBrief = true,
}) => {
  return (
    <div className='w-full'>
      {viewMode === 'brand' && <EnterpriseBrief campaign={campaign} />}

      {isCampaignInfoBrief && (
        <CampaignInfoBrief campaign={campaign} viewMode={viewMode} />
      )}

      <VideoBrief
        campaign={campaign}
        hooks={hooks}
        addons={addons}
        viewMode={viewMode}
      />
      <Divider className='py-8' />
      <ProductBrief campaign={campaign} />
      <Divider className='py-8' />
      <CreatorRequirementsBrief campaign={campaign} />
      <Divider className='py-8' />
      <InspirationBrief campaign={campaign} viewMode={viewMode} />
    </div>
  )
}

CampaignDetailsBrief.defaultProps = defaultProps

export { CampaignDetailsBrief }
